import React from 'react'

// fill: khung co theo chiều cao cha (flex column, min-h-0) để nội dung bên trong tự cuộn khi vượt quá
export default function FrameBorder({ children, fill = false }) {
	const fillCls = fill ? "min-h-0 flex flex-col" : "";
	return (
		<div className={`w-full rounded-[28px] sm:rounded-[38px] bg-[#FFE7A3] p-[1px] ${fillCls}`}>
			<div className={`rounded-[28px] sm:rounded-[38px] bg-[#FFB02E] p-[2px] shadow-[0_3px_8px_rgba(255,122,0,.35)] ${fillCls}`}>
				<div className={`rounded-[26px] sm:rounded-[38px] bg-[#FF6A00] p-[2px] ${fillCls}`}>
					<div className={`rounded-[26px] sm:rounded-[38px] bg-gradient-to-b from-[#FFF5E6] via-[#FEE3BB] to-[#F8D5A3] overflow-hidden ${fillCls}`}>
						{children}
					</div >
				</div>
			</div>
		</div>
	)
}
